import { ComponentType } from 'react';
import { components, GroupBase, MultiValueRemoveProps } from 'react-select';
import { Option } from '@connect-x-app/shared-types';
import { COLORS } from '@connect-x-app/shared-ui';

import { Icon } from '../../icon';

export const MultiValueRemove: ComponentType<MultiValueRemoveProps<Option, boolean, GroupBase<Option>>> | undefined = ({
  ...props
}) => (
  <components.MultiValueRemove {...props}>
    <Icon colorName={COLORS.yuma.$01} name="close" />
  </components.MultiValueRemove>
);
